import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.96052 5.96052C6.24121 5.67983 6.69629 5.67983 6.97698 5.96052L17.0395 16.023C17.3202 16.3037 17.3202 16.7588 17.0395 17.0395C16.7588 17.3202 16.3037 17.3202 16.023 17.0395L5.96052 6.97698C5.67983 6.69629 5.67983 6.24121 5.96052 5.96052Z",
		fill: "#DA1E28"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.0395 5.96052C17.3202 6.24121 17.3202 6.69629 17.0395 6.97698L6.97698 17.0395C6.69629 17.3202 6.24121 17.3202 5.96052 17.0395C5.67983 16.7588 5.67983 16.3037 5.96052 16.023L16.023 5.96052C16.3037 5.67983 16.7588 5.67983 17.0395 5.96052Z",
		fill: "#DA1E28"
	})]
});
export default SvgClose;
